export const PLACE_APPEARANCE_REFS: Readonly<any> = Object.freeze({
  category: {
    title: 'category-title',
    product: {
      name: 'category-product-name',
      description: 'category-product-description',
      weight: 'category-product-weight',
      cost: 'category-product-cost'
    }
  },
  dialog: {
    product: {
      name: 'dialog-product-name',
      description: 'dialog-product-description',
      weight: 'dialog-product-weight',
      cost: 'dialog-product-cost'
    },
    explanatoryMark: 'dialog-explanatory-mark',
    subTitle: 'dialog-sub-title',
    title: 'dialog-title',
    text: 'dialog-text'
  }
});

export const MONTH_NUMBERS: any = <any> Object.freeze({
  JANUARY: 0,
  FEBRUARY: 1,
  MARCH: 2,
  APRIL: 3,
  MAY: 4,
  JUNE: 5,
  JULY: 6,
  AUGUST: 7,
  SEPTEMBER: 8,
  OCTOBER: 9,
  NOVEMBER: 10,
  DECEMBER: 11
});

export const POSITIONS = Object.freeze({
  BOTTOM_LEFT: 'bottom-left',
  TOP_LEFT: 'top-left',
  BOTTOM_RIGHT: 'bottom-right',
  TOP_RIGHT: 'top-right',
  BOTTOM_CENTER: 'bottom-center',
  TOP_CENTER: 'top-center',
  CURSOR: 'cursor',
  SCREEN_CENTER: 'screen-center'
});

export const DEFAULT_TIMETABLE_ITEM: any = [
  [ 0, 0 ],
  [ 0, 0 ]
];

export const DEFAULT_TIMETABLE = [
  DEFAULT_TIMETABLE_ITEM,
  DEFAULT_TIMETABLE_ITEM,
  DEFAULT_TIMETABLE_ITEM,
  DEFAULT_TIMETABLE_ITEM,
  DEFAULT_TIMETABLE_ITEM,
  DEFAULT_TIMETABLE_ITEM,
  DEFAULT_TIMETABLE_ITEM
];

export const DEFAULT_PLACE = {
  id: '0',
  appearance: {
    category: {
      title: {
        fontStyle: 'normal',
        fontWeight: 'normal',
        textTransform: 'uppercase',
        textAlign: 'justify',
        fontSize: '24px',
        color: 'black',
        margin: '1em 0 0.5em 0'
      },
      containerTag: 'h1',
      itemsInRow: 4,
      orientation: 'vertical',
      product: {
        name: {
          fontStyle: 'normal',
          fontWeight: 'normal',
          textTransform: 'uppercase',
          textAlign: 'justify',
          fontSize: '24px',
          color: 'black'
        },
        description: {
          fontStyle: 'normal',
          fontWeight: 'normal',
          textTransform: 'uppercase',
          textAlign: 'justify',
          fontSize: '24px',
          color: 'black'
        },
        weight: {
          fontStyle: 'normal',
          fontWeight: 'normal',
          textTransform: 'uppercase',
          textAlign: 'justify',
          fontSize: '24px',
          color: 'black'
        },
        cost: {
          fontStyle: 'normal',
          fontWeight: 'normal',
          textTransform: 'uppercase',
          textAlign: 'justify',
          fontSize: '24px',
          color: 'black'
        }
      }
    },
    dialog: {
      title: {
        fontStyle: 'normal',
        fontWeight: 'normal',
        textTransform: 'uppercase',
        textAlign: 'justify',
        fontSize: '24px',
        color: 'black'
      },
      subTitle: {
        fontStyle: 'normal',
        fontWeight: 'normal',
        textTransform: 'uppercase',
        textAlign: 'justify',
        fontSize: '24px',
        color: 'black'
      },
      text: {
        fontStyle: 'normal',
        fontWeight: 'normal',
        textTransform: 'uppercase',
        textAlign: 'justify',
        fontSize: '24px',
        color: 'black'
      },
      explanatoryMark: {
        fontStyle: 'normal',
        fontWeight: 'normal',
        textTransform: 'uppercase',
        textAlign: 'justify',
        fontSize: '24px',
        color: 'black'
      },
      product: {
        name: {
          fontStyle: 'normal',
          fontWeight: 'normal',
          textTransform: 'uppercase',
          textAlign: 'justify',
          fontSize: '24px',
          color: 'black'
        },
        description: {
          fontStyle: 'normal',
          fontWeight: 'normal',
          textTransform: 'uppercase',
          textAlign: 'justify',
          fontSize: '24px',
          color: 'black'
        },
        cost: {
          fontStyle: 'normal',
          fontWeight: 'normal',
          textTransform: 'uppercase',
          textAlign: 'justify',
          fontSize: '24px',
          color: 'black'
        }
      }
    },
    input: {
      normal: {
        fontStyle: 'normal',
        fontWeight: 'normal',
        textTransform: 'uppercase',
        textAlign: 'justify',
        fontSize: '24px',
        color: 'black',
        background: 'transparent',
        border: {
          color: 'black',
          radius: '0px',
          weight: '1px'
        }
      },
      focus: {
        background: 'transparent'
      }
    }
  },
  name: '',
  country: '',
  address: '',
  emails: '',
  phones: '',
  sites: '',
  currency: '',
  tableLimit: 0,
  tableReservationLimit: 0,
  productLimit: 0,
  personLimit: 0,
  isReservationTBDefault: false,
  isTakeAwayTBDefault: false,
  averageVisitDuration: 0,
  highlightReservationBefore: 0,
  highlightTakeAwayBefore: 0,
  firstDayMon: false,
  smsTitle: '',
  timetable: DEFAULT_TIMETABLE,
  timetableReservation: DEFAULT_TIMETABLE,
  timetableTakeAway: DEFAULT_TIMETABLE
};
